// ~/utils/removeDiacritics.js
export function removeDiacritics(str = '') {
    if (typeof str !== 'string') return '';

    // Normalize to decomposed form (NFD) and remove combining marks
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};